/**
 * Whether the new design is on, for code outside React: `t()` and `getIntl()` pick their catalog by it, and so
 * does the little that must behave by design where no hook can be called. `Locales` keeps it in step with the
 * cached user. A component under the store asks `useIsNewDesign` instead, which re-renders it on a switch.
 */
let isOn = false;
const listeners = new Set<() => void>();

export const setNewDesignCopy = (isNewDesign: boolean): void => {
    if (isOn === isNewDesign) {
        return;
    }
    isOn = isNewDesign;
    listeners.forEach((listener) => listener());
};

export const isNewDesignCopy = (): boolean => isOn;

/**
 * Hears a switch, for `useSyncExternalStore` with `isNewDesignCopy`: a component that keeps what `t()` gave it
 * rebuilds it on the other catalog, with or without the store above it.
 */
export const onNewDesignCopyChange = (listener: () => void): (() => void) => {
    listeners.add(listener);
    return () => {
        listeners.delete(listener);
    };
};
